export async function copyToClipboard(text) {
    try {
      if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
      } else {
        return document.execCommand('copy', true, text);
      }
    } catch {
      return new Promise<void>((resolve, reject) => {
        const activeElement = document.activeElement;
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          resolve();
        } catch {
          reject();
        } finally {
          document.body.removeChild(textArea);
          (activeElement as HTMLElement)?.focus();
        }
      });
    }
  }

export async function copyHtmlToClipboard(html: string): Promise<boolean> {
    try {
      if ('clipboard' in navigator && 'ClipboardItem' in window) {
        const blob = new Blob([html], { type: 'text/html' });
        const clipboardItem = new ClipboardItem({ 'text/html': blob });
        await navigator.clipboard.write([clipboardItem]);
        return true;
      } else {
        await copyToClipboard(html);
        return true;
      }
    } catch {
      try {
        await copyToClipboard(html);
        return true;
      } catch {
        return false;
      }
    }
  }